import { publicClient, privateClient } from './client';
import { CurrencyFormat } from './CurrencyFormat';

const transactionsCurrencyFormat = (pub: boolean) => new CurrencyFormat(pub ? publicClient : privateClient);
export default transactionsCurrencyFormat;
